var map = {
	"./hemcap.jpg": 888,
	"./hemcap1.jpg": 8047,
	"./hemcapmould.jpg": 6723,
	"./hemcapmould1.jpg": 7694,
	"./hemdial.jpg": 6664,
	"./hemmould.jpg": 8261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2345;